import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';

const gqlGetRec = gql`
  query getEdocSeries($where: String, $offset: Int, $limit: Int, $order: String) {
    getEdocSeries(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: docPrefix
        description2: name
      }
      recordCount
    }
  }
`;

function useGetRecLazyQuery() {
  return useLazyQuery(gqlGetRec, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

export const FieldSelectSeries = ({
  label = 'Σειρά',
  name = 'seriesId',
  seriestypeId,
  defaultValues = {},
  ...rest
}: FsProps & { seriestypeId: number }) => {
  const sbLabel = (defaultValues as any)?.edocSeriesType?.name ?? undefined;
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      sbLabel={sbLabel}
      hook={useGetRecLazyQuery}
      where={JSON.stringify({ seriestypeId })}
    />
  );
};

